import type { ForumAdminContact } from '../types/forum';

/** Form / kart için geçerli kişi satırlarını süz. */
export function normalizeForumContacts(
  raw: ForumAdminContact[] | null | undefined
): ForumAdminContact[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((a) => ({
      name: (a?.name ?? '').trim(),
      profile_url: (a?.profile_url ?? '').trim(),
    }))
    .filter((a) => a.name !== '' || a.profile_url !== '');
}

/** @deprecated normalizeForumContacts kullanın */
export const normalizeForumAdmins = normalizeForumContacts;

/** Eski tekil alanlar + yeni dizi → tek liste (geriye uyum). */
export function resolveForumAdmins(forum: {
  forum_admins?: ForumAdminContact[] | null;
  forum_admin_name?: string | null;
  forum_admin_profile_url?: string | null;
}): ForumAdminContact[] {
  const fromJson = normalizeForumContacts(forum.forum_admins);
  if (fromJson.length > 0) return fromJson;

  const name = forum.forum_admin_name?.trim() || '';
  const profile_url = forum.forum_admin_profile_url?.trim() || '';
  if (!name && !profile_url) return [];
  return [{ name, profile_url }];
}

export function resolveForumControllers(forum: {
  forum_controllers?: ForumAdminContact[] | null;
}): ForumAdminContact[] {
  return normalizeForumContacts(forum.forum_controllers);
}

export function emptyForumAdminRow(): ForumAdminContact {
  return { name: '', profile_url: '' };
}

export const emptyForumControllerRow = emptyForumAdminRow;
